// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import SetHeaderAndDataRowIndices, {
  useSetHeaderAndDataRowIndices,
} from '../../../../components/SetHeaderAndDataRowIndices/SetHeaderAndDataRowIndices';
import { ProgressIndicator, useLink } from './_config';

export default function MapHeaderPage({ match }) {
  const link = useLink('mapHeader');
  const props = useSetHeaderAndDataRowIndices({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
  });

  const history = useHistory();

  return (
    <Layout>
      <ProgressIndicator step="identifyFields" />
      <PageHeader>
        <PageTitle>
          <Trans>Indicate header and data row</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>
            Indicate which row identifies field names and row where data starts.
          </Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <SetHeaderAndDataRowIndices {...props} />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateHeaderRow();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}
